export default __webpack_public_path__ + "static/media/214.9a5b97d6.jpg";